import React, { useEffect, useState } from 'react';
import classes from "./HomePage.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'primereact/button';
import { Calendar } from "primereact/calendar";
import moment from "moment-timezone";
import { DataTable } from "primereact/datatable";
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { liveMisApi, misApi } from '../http/http';
import Layout from '../components/Layout';
import { toast } from 'react-toastify';
import { removeToken } from '../store/slices/tokenSlice';
import { useNavigate } from 'react-router-dom';
import Spinner from '../components/Spinner';

const HomePage = () => {
    const { tokenData } = useSelector(state => state?.tokenSlice);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [data, setData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [total, setTotal] = useState(null);
    const [monthYear, setMonthYear] = useState(new Date());

    const handleMonthYearChange = (e) => {
        setMonthYear(e.value);
    };

    const [dates, setDates] = useState({
        to: moment(new Date()).format("yyyy-MM-DD"),
        from: moment().startOf("month").format("YYYY-MM-DD"),
    });

    const [startDateForCalendar, setStartDateForCalendar] = useState(
        moment().startOf("month").toDate()
    );
    const [endDateForCalendar, setEndDateForCalendar] = useState(new Date());

    const convertStartDate = (utcDate) => {
        setStartDateForCalendar(utcDate);
        // setEndDateForCalendar(moment(utcDate).add(30, 'days').toDate());
        setDates({
            ...dates,
            // to: moment(new Date(utcDate)).add(30, "days").format("yyyy-MM-DD"),
            from: moment(new Date(utcDate)).format("yyyy-MM-DD"),
        });
    };

    const convertEndDate = (utcDate) => {
        // setStartDateForCalendar(moment(utcDate).subtract(30, 'days').toDate());
        setEndDateForCalendar(utcDate);
        setDates({
            ...dates,
            // from: moment(new Date(utcDate)).subtract(30, 'days').format("yyyy-MM-DD"),
            to: moment(new Date(utcDate)).format("yyyy-MM-DD")
        });
    };

    console.log(tokenData, 'tokenData...');
    const fetchMis = async () => {
        try {
            setLoading(true);

            const startDate = moment(monthYear).startOf("month").format("YYYY-MM-DD");
            const endDate = moment(monthYear).endOf("month").format("YYYY-MM-DD");

            // const response = await misApi(dates.from, dates.to, tokenData);
            const response = await misApi(startDate, endDate, tokenData);
            console.log(response, 'response...');
            const response2 = response?.data?.result?.filter((item) => {
                if (moment(item?.mis_date).isSameOrBefore(new Date())) {
                    return { ...item }
                }
            })
            setData(response2.reverse());
            fetchLiveMis();

            // const total_subscriptions_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_subscriptions ?? 0),
            //     0
            // );

            // const total_unsubscriptions_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_unsubscriptions ?? 0),
            //     0
            // );

            // const subscription_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.subscription_revenue ?? 0),
            //     0
            // );

            // const renewal_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.renewal_revenue ?? 0),
            //     0
            // );

            // const total_revenue_sum = response?.data?.result.reduce(
            //     (total, dataItem) => total + Number(dataItem.total_revenue ?? 0),
            //     0
            // );

            // setTotal({
            //     mis_date: "Totals",
            //     total_base: "",
            //     total_subscriptions: total_subscriptions_sum.toFixed(2),
            //     total_unsubscriptions: total_unsubscriptions_sum.toFixed(2),
            //     subscription_revenue: subscription_revenue_sum.toFixed(2),
            //     renewal_count: "",
            //     renewal_revenue: renewal_revenue_sum.toFixed(2),
            //     total_revenue: total_revenue_sum.toFixed(2),
            // });


        } catch (error) {
            console.log(error, 'error');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    const fetchLiveMis = async () => {
        try {
            const response = await liveMisApi(tokenData);
            setLoading(false);

            setLiveData(response?.data?.result);

        } catch (error) {
            console.log(error, 'error');
            setLoading(false);

            if (error?.response?.status == 403) {
                dispatch(removeToken());
                toast.error("Token Expired, Please Login Again!");
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    console.log(data, 'data...');
    useEffect(() => {
        fetchMis();
    }, [monthYear]);

    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="Date" rowSpan={2} />
                <Column header="Total Active Base" rowSpan={2} />
                <Column header="Unsubscriptions" colSpan={3} />
                <Column header="Subscriptions" colSpan={3} />
                <Column header="Sub Charged" colSpan={3} />
                <Column header="Renewals" colSpan={3} />
                <Column header="Revenue" colSpan={3} />
            </Row>
            <Row>
                <Column header="Weekly" />
                <Column header="Daily" />
                <Column header="Total" />
                <Column header="Weekly" />
                <Column header="Daily" />
                <Column header="Total" />
                <Column header="Weekly" />
                <Column header="Daily" />
                <Column header="Total" />
                <Column header="Weekly" />
                <Column header="Daily" />
                <Column header="Total" />
                <Column header="Sub" />
                <Column header="Ren" />
                <Column header="Total" />
            </Row>
        </ColumnGroup>
    );


    return (
        <>
            <Layout active={0}>

                <div className={classes.date_containers}>
                    <div className={classes.date_container}>
                        {/* <Calendar
                            value={startDateForCalendar}
                            onChange={(e) => convertStartDate(e.value)}
                            showIcon
                            showButtonBar
                            placeholder="Start Date"
                            style={{ width: "100%" }}
                            maxDate={endDateForCalendar}
                        /> */}

                        <Calendar
                            showIcon
                            showButtonBar
                            placeholder="Month / Year"
                            style={{ width: "100%" }}
                            view="month"
                            dateFormat="mm/yy"
                            value={monthYear}
                            onChange={handleMonthYearChange}
                            maxDate={new Date()}
                        />
                    </div>
                    {/* <div className={classes.date_container}>
                        <Calendar
                            value={endDateForCalendar}
                            onChange={(e) => convertEndDate(e.value)}
                            showIcon
                            // touchUI
                            showButtonBar
                            placeholder="End Date"
                            style={{ width: "100%" }}
                            minDate={startDateForCalendar}
                            maxDate={new Date()}
                        />
                    </div> */}

                    {/* <Button label='Search' onClick={fetchMis} /> */}

                </div>

                <div className={classes.message_container}>
                    {/* <i className="pi pi-info-circle" style={{color:"#1F41BA",fontSize:"18px"}} /> */}
                    <p className={classes.message_title}>Revenue Report</p>
                </div>

                {loading ? <Spinner /> : (
                    <div className={classes.table_container}>
                        <DataTable
                            value={[liveData, ...data]}
                            emptyMessage="No data found"
                            showGridlines
                            responsive
                            scrollable
                            scrollDirection="both"
                            scrollHeight="500px"
                            rows={40}
                            paginator
                            headerColumnGroup={headerGroup}
                        >
                            <Column field="mis_date_time" header="Date"
                                body={(rowData) =>
                                    moment(rowData?.mis_date_time).format("DD-MM-YYYY")
                                }
                            />
                            <Column
                                field="total_active_base"
                                header="Total Active Base"
                            />
                            <Column
                                field="unsub_weekly"
                                header="Unsub Weekly"
                            />
                            <Column
                                field="unsub_daily"
                                header="Unsub Daily"

                            />
                            <Column
                                field="unsubscriptions"
                                header="Unsubscriptions"
                                body={(rowData) =>
                                    rowData?.unsubscriptions ?? rowData?.unsubs
                                }
                            />
                            <Column
                                field="sub_weekly"
                                header="Sub Weekly"
                            />
                            <Column
                                field="sub_daily"
                                header="Sub Daily"

                            />
                            <Column
                                field="subscriptions"
                                header="Subscriptions"
                                body={(rowData) =>
                                    rowData?.subscriptions ?? rowData?.subs
                                }
                            />
                            <Column
                                field="sub_charged_weekly"
                                header="Sub Charged Weekly"
                            />
                            <Column
                                field="sub_charged_daily"
                                header="Sub Charged Daily"
                            />
                            <Column
                                field="sub_charged"
                                header="Sub Charged"
                            />
                            <Column
                                field="renewal_weekly"
                                header="Ren Weekly"
                                body={(rowData) =>
                                    rowData?.renewal_weekly ?? rowData?.ren_weekly
                                }
                            />
                            <Column
                                field="renewal_daily"
                                header="Ren Daily"
                                body={(rowData) =>
                                    rowData?.renewal_daily ?? rowData?.ren_daily
                                }

                            />
                            <Column
                                field="renewals"
                                header="Renewals"
                            />
                            <Column
                                field="sub_revenue"
                                header="Sub Revenue"
                            />
                            <Column
                                field="renewal_revenue"
                                header="Ren Revenue"
                                body={(rowData) =>
                                    rowData?.renewal_revenue ?? rowData?.ren_revenue
                                }
                            />
                            <Column
                                field="total_revenue"
                                header="Total Revenue"
                            />
                        </DataTable>
                    </div>
                )}


            </Layout>

        </>

    )
}

export default HomePage